import React, { useState, useContext, useEffect } from "react";
import { useSelector } from "react-redux";
import {
  Box,
  Typography,
  IconButton,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  Paper,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Loader from "../Components/Loader";
import { ToastContext } from "../utils/ToastContext";
import {
  editLead,
  dispositionData,
} from "../Services/leadsService/ManageLeadsService";
import {
  callDispo,
  callSubDispo,
  leadPriorityOptions,
} from "../utils/Helpers/CallDispoValues";

const CallDispositionModal = ({ open, onClose, leadPhone }) => {
  const [loader, setLoader] = useState(false);
  const { showToast } = useContext(ToastContext);
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedTime, setSelectedTime] = useState("");

  const userDetails = useSelector((state) => state.user.userDetails);
  const accessKey = userDetails.UserDetails.accesskey;
  const secretKey = userDetails.UserDetails.secretkey;

  const [callDispositionList, setCallDispositionList] = useState([]);
  const [callSubDispositionList, setSubCallDispositionList] = useState([]);
  const [selectedCallDisposition, setSelectedCallDisposition] = useState("");
  const [leadData, setLeadData] = useState([]);

  const [selectedOptions, setSelectedOptions] = useState({
    callDispositionList: "",
    leadPriority: "",
    callSubDispositionList: "",
  });
  const [isDisabled, setIsDisabled] = useState(false);

  const today = new Date();
  const maxDate = new Date(
    today.getFullYear() + 5,
    today.getMonth(),
    today.getDate()
  )
    .toISOString()
    .split("T")[0];
  const minDate = today.toISOString().split("T")[0];

  // const [countDown, setCountdown] = useState("Ended");

  useEffect(() => {
    loadCallDispositionList();
    // loadSubCallDispositionList();
  }, []);

  useEffect(() => {
    getLeadData();
  }, []);

  useEffect(() => {
    filterSubDispositions();
  }, [selectedCallDisposition]);

  const convertToUTC = (istTime) => {
    if (!istTime) return "";

    const [hours, minutes] = istTime.split(":").map(Number);

    const date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes);

    date.setHours(date.getHours() - 5);
    date.setMinutes(date.getMinutes() - 30);

    const utcHours = String(date.getHours()).padStart(2, "0");
    const utcMinutes = String(date.getMinutes()).padStart(2, "0");

    return `${utcHours}:${utcMinutes}`;
  };

  const getLeadData = async () => {
    try {
      if (leadPhone) {
        const payload = {
          leadId: "",
          phoneNumber: leadPhone,
        };
        const data = await dispositionData(payload);
        setLeadData(data.data?.callDispositionData[0]);
      } else {
        showToast("Phone number is not valid", "error");
      }
    } catch (error) {
      setLoader(false);
      showToast("Something Went Wrong", "error");
    }
  };

  // useEffect(() => {
  //   let timer;
  //   if (leadData?.mx_referral_end_time) {
  //     timer = setInterval(() => {
  //       const timeRemaining = getTimeRemaining(leadData?.mx_referral_end_time);
  //       setCountdown(timeRemaining);
  //     }, 1000);
  //   }
  //   return () => clearInterval(timer);
  // }, [leadData?.mx_referral_end_time]);

  // const getTimeRemaining = (endTime) => {
  //   const total = Date.parse(endTime) - Date.now();
  //   if (total <= 0) {
  //     return "Ended";
  //   }
  //   const seconds = Math.floor((total / 1000) % 60);
  //   const minutes = Math.floor((total / 1000 / 60) % 60);
  //   const hours = Math.floor(total / (1000 * 60 * 60));
  //   return `${hours.toString().padStart(2, "0")}H : ${minutes
  //     .toString()
  //     .padStart(2, "0")}M : ${seconds.toString().padStart(2, "0")}S remaining`;
  // };

  const loadCallDispositionList = async () => {
    if (callDispositionList.length === 0) {
      setLoader(true);
      // try {
      // const data = await getCallDispositionList();
      // const options = data.data.callDispositionMaster.map(
      //   (stage) => stage.name
      //  );
      //   console.log("call disposition options: ", options);
      setCallDispositionList(callDispo);
      setLoader(false);
      //} catch (error) {
      setLoader(false);
      //showToast("Something Went Wrong", "error");
      //}
    }
  };

  // const loadSubCallDispositionList = async () => {
  //   setLoader(true);
  //   try {
  //     const data = await getCallSubDispositionList();
  //    console.log("call sub dispo: ", data.data.callSubDispositionMaster);
  //    setFilteredSubDispositions(data.data.callSubDispositionMaster);
  //  setLoader(false);
  // } catch (error) {
  //    setLoader(false);
  //    showToast("Something Went Wrong", "error");
  //   }
  // };

  const filterSubDispositions = () => {
    if (!selectedCallDisposition) return;
    const key = selectedCallDisposition.toLowerCase().replace(/[^a-z0-9]/g, "");
    const filteredOptions = callSubDispo
      .filter((option) => option[key] === true)
      .map((option) => option.name);
    setSubCallDispositionList(filteredOptions);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setSelectedOptions((prev) => ({ ...prev, [name]: value }));
    if (name === "callDispositionList") {
      setSelectedCallDisposition(value);
      setSelectedOptions((prev) => ({
        ...prev,
        callSubDispositionList: "",
        leadPriority: "",
      }));
      setSelectedDate("");
      setSelectedTime("");
    }
  };

  const handleSetDate = (e) => {
    // console.log(e.target.value > maxDate);
    if (
      selectedOptions.callDispositionList === "WIP" &&
      (e.target.value > maxDate || e.target.value < minDate) &&
      !selectedDate
    ) {
      showToast("Dates outside Range", "warning");
      setIsDisabled(true);
    } else {
      setSelectedDate(e.target.value);
      setIsDisabled(false);
    }
  };

  const handleDispositionForm = async () => {
    const hasEmptyDispositions =
      selectedOptions.callDispositionList === "" ||
      selectedOptions.callSubDispositionList === "";

    if (hasEmptyDispositions) {
      showToast(
        "Please Select Disposition and Sub Disposition Options",
        "error"
      );
      return;
    }

    if (selectedOptions.callDispositionList === "WIP") {
      if (
        selectedOptions.callSubDispositionList === "" ||
        !selectedDate ||
        !selectedTime
      ) {
        showToast("Please Select all disposition options", "error");
        return;
      }
    }

    if (isDisabled) {
      showToast("Dates outside range", "error");
      setSelectedDate("");
      return;
    }

    let payload = [
      {
        Attribute: "mx_lead_priority",
        Value: selectedOptions.leadPriority,
      },
      {
        Attribute: "mx_telecalling_substage",
        Value: selectedOptions.callSubDispositionList,
      },
      {
        Attribute: "mx_telecalling_stage",
        Value: selectedOptions.callDispositionList,
      },
    ];

    if (selectedDate && selectedTime) {
      payload.push({
        Attribute: "mx_call_back_date_time",
        Value: `${selectedDate} ${convertToUTC(selectedTime)}`,
      });
    }

    try {
      const data = await editLead(
        payload,
        leadData?.leadsid,
        "",
        "",
        accessKey,
        secretKey
      );
      if (data.message === "success" && data.success === true) {
        setLoader(false);
        onClose();
        showToast("Request Process Successfully!", "success");
      } else {
        setLoader(false);
        showToast(data.message, "error");
      }
    } catch (error) {
      setLoader(false);
      onClose();
      showToast("Oops Something Went Wrong!", "error");
    }
  };

  const formatDetail = (label, value) => `${label} - ${value || "NA"}`;

  if (!open) return null;

  return (
    <div
      style={{
        position: "fixed",
        zIndex: 1000,
        left: 100,
        bottom: 30,
        pointerEvents: "auto",
      }}
    >
      <div
        style={{
          height: "500px",
          width: "650px",
          backgroundColor: "white",
          borderTopLeftRadius: 10,
          borderTopRightRadius: 10,
          boxShadow: "0 10px 20px rgba(0,0,0,0.5)",
        }}
      >
        {loader && <Loader />}
        <Paper
          sx={{
            padding: 4,
            height: "100%",
            width: "100%",
            overflowY: "auto",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 2,
            }}
          >
            <Typography variant="h6">Call Disposition Form</Typography>
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Box>

          <Box sx={{ marginTop: 2 }}>
            <Typography>
              Select the relevant disposition for{" "}
              <strong>{leadData?.leadname || "[No Name]"}</strong>
            </Typography>

            <Typography
              variant="h6"
              sx={{
                marginTop: 3,
                marginBottom: 2,
                borderBottom: "1px solid",
                borderColor: "divider",
                paddingBottom: 1,
              }}
            >
              Lead Details
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4}>
                <Typography>
                  {formatDetail(
                    "Last Disposition",
                    leadData?.mx_telecalling_stage
                  )}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Typography>
                  {formatDetail("Referee Code", leadData?.mx_referee_code)}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Typography>
                  {formatDetail("Referee Name", leadData?.mx_referee_name)}
                </Typography>
              </Grid>
            </Grid>

            <Typography
              variant="h6"
              sx={{
                marginTop: 3,
                marginBottom: 2,
                borderBottom: "1px solid",
                borderColor: "divider",
                paddingBottom: 1,
                display: "flex",
                justifyContent: "start",
                gap: "30px",
                alignItems: "center",
                wordBreak: "break-word",
              }}
            >
              <span>Disposition Form</span>
              {/* {countDown !== "Ended" &&
                leadData?.mx_primary_source === "Client_Referral" && (
                  <span style={{ fontSize: "0.65em", color: "red" }}>
                    Eligible for Referral Discount of 10% - {countDown}
                  </span>
                )} */}
            </Typography>

            <Grid container spacing={2}>
              <Grid item xs={12} sm={4}>
                <FormControl fullWidth>
                  <InputLabel>Disposition Type</InputLabel>
                  <Select
                    name="callDispositionList"
                    value={selectedOptions.callDispositionList}
                    onChange={handleChange}
                    label="Disposition Type"
                    sx={{ height: "50px" }}
                  >
                    {callDispositionList.map((option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={4}>
                <FormControl fullWidth>
                  <InputLabel>Sub-Disposition Type</InputLabel>
                  <Select
                    name="callSubDispositionList"
                    value={selectedOptions.callSubDispositionList}
                    onChange={handleChange}
                    label="Sub-Disposition Type"
                    sx={{ height: "50px" }}
                  >
                    {callSubDispositionList.map((option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={4}>
                <FormControl fullWidth>
                  <InputLabel>Lead Priority</InputLabel>
                  <Select
                    name="leadPriority"
                    value={selectedOptions.leadPriority}
                    onChange={handleChange}
                    label="Lead Priority"
                    sx={{ height: "50px" }}
                  >
                    {leadPriorityOptions.map((option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              {selectedOptions.callDispositionList === "WIP" && (
                <>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      sx={{ height: "40px" }}
                      type="date"
                      label="Select Date"
                      value={selectedDate}
                      onChange={handleSetDate}
                      inputProps={{
                        min: minDate,
                        max: maxDate,
                        onKeyDown: (e) => e.preventDefault(),
                      }}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      sx={{ height: "40px" }}
                      type="time"
                      label="Select Time"
                      value={selectedTime}
                      onChange={(e) => setSelectedTime(e.target.value)}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                </>
              )}
            </Grid>
          </Box>
          <Box
            sx={{
              marginTop: 3,
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button variant="contained" onClick={handleDispositionForm}>
              Save
            </Button>
          </Box>
        </Paper>
      </div>
    </div>
  );
};

export default CallDispositionModal;
